import { useTheme } from "@amx/ux-twoui-theming";
import { Stack, StackItem } from "@fluentui/react";
import React from "react";
import { useViewport } from "../../../../../styles";
import { SlotStack, SlotStackItem } from "../../../../Stacks/SlotStack/SlotStack";
import { LinkListFooterLink } from "../LinkListFooter";
import { linkListFooterContainerStyle } from "../LinkListFooter.styles";
import { LinkListFooterTwoColumnProps } from "../LinkListFooter.types";

export const LinkListFooterTwoColumn: React.FC<LinkListFooterTwoColumnProps> = ({
    leftLink,
    rightLink,
    borderRadius = true,
    shadow = true
}) => {
    const theme = useTheme();
    const viewportType = useViewport();

    const sideLayout = (
        <SlotStack totalSlots={12}>
            <SlotStackItem slots={6}>
                <LinkListFooterLink {...leftLink} />
            </SlotStackItem>
            <SlotStackItem slots={6}>
                <LinkListFooterLink {...rightLink} />
            </SlotStackItem>
        </SlotStack>
    );

    const stackedLayout = (
        <Stack horizontal={false} tokens={{childrenGap: "16px"}}>
            <StackItem>
                <LinkListFooterLink {...leftLink} />
            </StackItem>
            <StackItem>
                <LinkListFooterLink {...rightLink} />
            </StackItem>
        </Stack>
    );

    const getLinkedListFooterItems = () => {
        switch (viewportType) {
            case "xxxl":
            case "xxl":
            case "xl":
            case "l":
                return sideLayout;
            case "m":
            case "s":
                return stackedLayout;
        }
    };

    return (
        <Stack verticalAlign="center" styles={linkListFooterContainerStyle(theme, borderRadius, shadow)}>
            <Stack style={{ margin: "9px 0 9px 0" }}>
                {getLinkedListFooterItems()}
            </Stack>
        </Stack>
    );
};
